export const text = {
  submit: "Submit",
  goBack: "Go Back",
  close: "Close",
  preview: "Preview",
  search: "Search",
  reset: "Reset",
  emailId: "Email id",
  loginOrCreate: "Login or Create Account",
  verification: "Verification",
  verify: "Verify",
  firstName: "First Name",
  lastName: "Last Name",
  phoneNumber: "Phone Number",
  cancel: "Cancel",
  displayName: "Display Name",
  fullName: "Full Name",
  middleName: "Middle Name",
  email: "Email",
  edit: "Edit",
  joined: "Joined",
  dateJoined: "Date Joined",
  join: "Join",
  createNewLoop: "Create a new Loop ",
  skip: "Skip",
  next: "Next",
  status: "Status",
  action: "Action",
  sno: "S.No.",
  areYouSure: "Are you sure",
  yes: "Yes",
  no: "No",
  dashboard: "dashboard",
  view: "View",
  deActivate: "Deactivate",
  activate: "Activate",
  subscriptionPlan: "Subscription Plan",
  lastLogin: "Last Login",
  createdAt: "Created At",
  editProfile: "Edit Profile",
  saveChanges: "Save Changes",
  continue: "Continue",
  logout: "Logout",
  update: "Update",
  add: "Add",
  delete: "Delete",
  date: "Date",
  to: "To",
  roles: "Roles",
  filter: "Filter",
  noRecordFound: "No Record Found",
  imageOnlyMessgae: "Please add either a JPEG, JPG or a PNG file",
  imageSizeExceedingMessage: "Please add a file not exceeding 15MB",
  wantToLogout: "Logout",
  areYouSureLogout: "Are you sure want to logout?",
  changePhoto: "Change Photo",
  viewProfile: "View Profile",
  signOut: "Sign out",
  subscriptionAmount: "Subscription Amount",
  subscriptionType: "Subscription Type",
  name: "Name",
  readMore: "Read More",
  active: "Active",
  youWantToActivateThisSubscriptionPlan:
    "you want to activate this Subscription Plan?",
  youWantToDeactivateThisSubscriptionPlan:
    "you want to deactivate this Subscription Plan?",
  warning: "warning",
  youWantToDeleteThisSubscriptionPlan:
    "you want to delete this Subscription Plan?",
  addSubscription: "Add Subscription",
  editSubscription: "Edit Subscription",
  manageSubscription: "Manage Subscription",
  enterVerificationCode: "Enter Verification Code✍️",
  successfull: "Successfull",
  successfully: "Successfully",
  okay: "Okay",
  features: "Features",
  switch: "Switch",
  back: "Back",
  serialNo: "Serial No",
  loadMore: "Load More",
  type: "Type",
  confirm: "Confirm",
  save: "Save",
  mobileNumber: "Mobile",
  pin: "Pin",
  unPinMessageText: "Unpin Message",
  pinMessageText: "Pin Message",
  imageTooltip: "Image Tooltip",
  viewDetails: "View Details",
  remove: "Remove",
  viewAll: "View All",
  notification: "Notifications",
  markAsRead: "Mark All Read",
  areYouSureToRemove: "Are you sure you want to remove this ?",
  confirmRemove: "Yes, remove it",
  storageAlmostFull: "Storage Almost Full",
  storageFull: "Storage Full",
  publishNow: "Publish Now",
  sendReport: "Send Report",
  reasonForReport: "Reason for Report",
  create: "Create",
  imageOnlyMessage: "Please add either a JPEG, JPG or a PNG file",
  send: "Send",
  choosePlan: "Get Started or Choose a Plan",
  yourJourney: "Initiate Your Journey",
  popular: "Popular",
  oneTimePayment: "One Time Payment",
  memorialPage: "Memorial Page",
  gbStorage: "GB Of Storage",
  photos: "Photos",
  videos: "Videos",
  audioRecordings: " Audio Recordings",
  pdf: "PDFs",
  buyPlan: "Buy Plan",
  chooseTheme: "Choose a Theme",
  livePreview: "Live Preview",
  createMemorial: "Create Memorial",
  orderSummary: "Order Summary",
  biographyPage: "Biography Page",
  layoutOptions: "Layout Options",
  about: "About",
  share: "Share",
  unsave: "Unsave",
  payNow: "Pay Now",
};
